<template>
  <el-drawer
    custom-class="drawer-custom-class"
    append-to-body
    :close-on-press-escape="false"
    :title="title"
    size="920px"
    :visible.sync="visible"
    direction="rtl"
    @closed="onClosed">
    <div
      v-loading="loading"
      class="drawer-wrap">
      <el-form
        label-width="85px"
        @submit.native.prevent>
        <el-row
          :gutter="8"
          type="flex">
          <el-col :span="12">
            <el-form-item label-width="0">
              <el-button
                type="primary"
                @click="handleCurrentChange(1)">查询</el-button>
              <download-button
                :taskType="11"
                style="margin-left: 10px;"
                :createDownloadFile="createDownloadFile"
                :validate="onValidate" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        :data="list"
        row-key="tagAssignId"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          label="鉴定中心"
          fixed="left"
          min-width="200"
          prop="roomName"></el-table-column>
        <el-table-column
          label="标签序号"
          min-width="180"
          prop="beginTagNo">
          <template slot-scope="{ row }">{{ row.beginTagNo | tagCount() }}-{{ row.endTagNo | tagCount() }}</template>
        </el-table-column>
        <el-table-column
          label="发放数量"
          width="90"
          prop="tagCount"></el-table-column>
        <el-table-column
          label="未使用数量"
          width="90"
          :formatter="row => row.tagCount - row.usedTagCount"
          prop="usedTagCount"></el-table-column>
        <el-table-column
          label="发放时间"
          width="150">
          <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="120">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="viewDetail(row)">查看</el-button>
            <el-dropdown>
              <el-button
                type="text"
                style="margin-left: 10px">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="cancelAllocationLabel(row)">取消分配</el-dropdown-item>
                <el-dropdown-item @click.native="handleRecycle(row)">回收标签</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </div>

    <apply-tag-detail-list-modal ref="applyTagDetailListModal" />
    <label-recycle-modal
      ref="recycleModal"
      @success="fetchList" />
  </el-drawer>
</template>

<script>
import AppraiseLable from '@/service/appraiseLable'
import ApplyTagDetailListModal from './apply-tag-detail-list-modal.vue'
import LabelRecycleModal from './label-recycle-modal.vue'
import DownloadButton from '@/components-v2/download-center/download-button.vue'
import Download from '@/service/download'
export default {
  name: 'LabelAllocationModal',
  components: { ApplyTagDetailListModal, LabelRecycleModal, DownloadButton },
  data() {
    return {
      visible: false,
      loading: false,
      createDownloadFile: Download.downloadtaguseinfos,
      multipleSelection: [],
      config: { pageNum: 1, pageSize: 20, roomId: null, roomName: '' },
      list: [],
      total: 0
    }
  },
  computed: {
    title({ config }) {
      return `${config.roomName}的标签发放记录`
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onValidate() {
      return new Promise((resolve, reject) => {
        if (this.multipleSelection.length === 0) {
          this.$message.error('请选择要下载的记录')
          reject('')
        } else {
          const tagAssignId = this.multipleSelection.map(item => item.tagAssignId).join(',')
          resolve({
            query: { tagAssignId },
            total: this.multipleSelection.length
          })
        }
      })
    },
    viewDetail(row) {
      this.$refs.applyTagDetailListModal.fetch({ tagAssignId: row.tagAssignId })
    },
    handleRecycle(row) {
      this.$refs.recycleModal.init({
        tagAssignId: row.tagAssignId,
        minTagNo: row.beginTagNo,
        maxTagNo: row.endTagNo
      })
    },
    onClosed() {
      this.config = { ...this.config, ...this.$options.data().config }
      this.total = 0
      this.list = []
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    cancelAllocationLabel(row) {
      this.$confirm('是否取消分配?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          AppraiseLable.deletetagassign({ tagAssignId: row.tagAssignId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('取消成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    fetchList() {
      this.loading = true
      AppraiseLable.gettagassigns({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(row) {
      this.visible = true
      this.config = { ...this.config, ...row }
      this.fetchList()
    }
  }
}
</script>
